import * as Config from '../../../config';
import React from 'react';
import PropTypes from 'prop-types';

import AvatarInitials from '../common/AvatarInitials';

function Avatar({ name, source, className, style, color = null }) {

  const myStyleAvatar = color ? {
    backgroundImage: `url(${source})`,
    border: `1.5px solid ${color}`
  } : { backgroundImage: `url(${source})` };

  const myStyleAvatarInitial = color ? {
    backgroundColor: color
  } : {};

  return (source && source !== Config.DEFAULT_AVATAR)
    ? <div className={`avatar-pm ${className}`} style={{...myStyleAvatar, ...style}} />
    : <AvatarInitials className={`avatar-initials-pm ${className}`} styleSpan={{...myStyleAvatarInitial, ...style}} disable={false} name={name} isRound={true} />
}

Avatar.propTypes = {
  name: PropTypes.string.isRequired,
  source: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
}

export default Avatar;
